var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleInfoFilled = function SvgCircleInfoFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31445 4.81497C7.11133 4.63138 7.00977 4.38724 7.00977 4.08255C7.00977 3.77786 7.11133 3.53372 7.31445 3.35013C7.51758 3.16653 7.78125 3.07474 8.10547 3.07474C8.42969 3.07474 8.69141 3.16653 8.89063 3.35013C9.09375 3.52982 9.19531 3.77396 9.19531 4.08255C9.19531 4.39114 9.09375 4.63724 8.89063 4.82083C8.69141 5.00052 8.42969 5.09036 8.10547 5.09036C7.78125 5.09036 7.51758 4.99857 7.31445 4.81497ZM7.17969 12.1333V5.79935H9.04297V12.1333H7.17969Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleInfoFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-info-filled.de80fa6b0ab81f96c5af72f195025545.svg";